var arrayFromConstructorAndList = require('../internals/array-from-constructor-and-list');
var typedArraySpeciesConstructor = require('../internals/typed-array-species-constructor');

module.exports = function (instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/typed-array-from-species-and-list.js